<template>
  <Editor id="tinymceId" v-model="myValue" :init="editorInit"/>
</template>

<script type="text/ecmascript-6">
/*
* 组件引用
* <editor v-model="content"></editor>
* */
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver/theme'
import 'tinymce/icons/default/icons'
import 'tinymce/plugins/link'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/anchor'
import 'tinymce/plugins/autolink' // 锚点
import 'tinymce/plugins/autoresize'
import 'tinymce/plugins/autosave'
import 'tinymce/plugins/charmap' // 特殊字符
import 'tinymce/plugins/code' // 查看源码
import 'tinymce/plugins/hr' // 横线
import 'tinymce/plugins/image' // 图片
import 'tinymce/plugins/importcss' // 图片工具
import 'tinymce/plugins/insertdatetime' // 时间插入
import 'tinymce/plugins/paste' // 粘贴
import 'tinymce/plugins/preview' // 预览
import 'tinymce/plugins/quickbars' // 快捷菜单
import 'tinymce/plugins/searchreplace' // 查询替换
import 'tinymce/plugins/tabfocus' //
import 'tinymce/plugins/template' // 插入模板
import 'tinymce/plugins/textpattern' //
import 'tinymce/plugins/visualblocks' //
import 'tinymce/plugins/wordcount' // 数字统计
import $updateFile from '@/assets/js/uploadFile'
import {compress} from '@/assets/js/common'

export default {
  components: {
    Editor
  },
  props: {
    value: {
      type: String,
      default () {
        return ''
      }
    },
    // 插件
    plugins: {
      type: [String, Array],
      default: 'wordcount visualblocks textpattern tabfocus searchreplace quickbars preview paste insertdatetime importcss image hr code charmap link code table lists advlist anchor autolink autoresize autosave'
    },
    // 工具栏
    toolbar: {
      type: [String, Array],
      default:
       'formats undo redo paste fontsizeselect fontselect |wordcount ltr rtl visualblocks searchreplace|preview image|outdent indent aligncenter alignleft alignright alignjustify lineheight underline h2 h3 blockquote numlist bullist table removeformat forecolor backcolor bold italic strikethrough hr charmap link insertdatetime subscript superscript code'
    }
  },
  data () {
    return {
      editorInit: {
        language_url: require('@/assets/tinymce/zh_CN.js'),
        language: 'zh_CN',
        skin_url: require('@/assets/tinymce/skins/ui/oxide/skin.css'),
        content_css: require('@/assets/tinymce/skins/content/default/content.css'),
        min_height: 450,
        // menubar: false, // 隐藏菜单栏
        toolbar: this.toolbar,
        plugins: this.plugins,
        images_upload_handler: (blobInfo, success, failure) => {
          this.imgUpload(blobInfo, success, failure)
        },
        paste_data_images: true,
        paste_webkit_styles: 'all'
      },
      myValue: this.value
    }
  },
  watch: {
    value (n) {
      this.myValue = n
    },
    myValue (v) {
      this.$emit('input', v)
    }
  },
  mounted () {
    tinymce.init({})
  },
  methods: {
    imgUpload (blob, success, failure) {
      compress(blob.blob(), {quality: 0.5}, file => {
        $updateFile('archives', file, key => {
          $updateFile('archives', key, url => {
            success(url)
          }, 1)
        })
      })
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/tinymce/index.vue